import { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Stack,
  Typography,
  Select,
  MenuItem,
  Button,
  Grid,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { Box } from '@mui/system';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import CustomDate from '../../components/CustomDate';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import aadharBackDummy from './dummy/aadharBackDummy.png';
import panCardDummy from './dummy/panCardDummy.jpg';
import cancelChequeDummy from './dummy/cancelChequeDummy.png';
import gstRegistrationCertificate from './dummy/GSTRegistrationCertificate.jpg';
import incorporationCertificate from './dummy/certificateIncorporation.jpg';
import logoDummy from './dummy/logoDummy.png';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import USERLIST from '../../_mocks_/user';
import {
  getCityData,
  getDocsTypesData,
  getPartnerCompanyType,
  getPartnerTypesData,
  getStateData,
  PreviewImageApi,
  saveApiData,
  setCityData
} from '../../store/Slice/Global/GlobalSlice';
import CustomSelect from '../../components/CustomSelect';
import CustomInput from '../../components/CustomInput';
import { OnboardingApi } from '../../utils/Apis';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import { isValidValue } from '../../utils/CommonFunction';
import PartnerHierarchyPage from './PartnerHierarchyComponent';
import {
  getOnboardingView,
  getReportingManagerList
} from '../../store/Slice/Onboarding/OnboardingSlice';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { savefileApiData } from '../../store/Slice/Payout/PayoutSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const validationSchema = yup.object().shape({
  // Mobile (always required)
  mobile: yup
    .string()
    .required('Mobile number is required')
    .matches(/^[6-9][0-9]{9}$/, 'Enter a valid 10-digit mobile number'),

  // Email (always required)
  emailAddress: yup.string().required('Email is required').email('Enter a valid email address'),

  // Partner Name
  partnerName: yup.string().required('Name is required'),

  dob: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('partnerType1', {
      is: 66, // Individual
      then: (schema) =>
        schema
          .required('Date of Birth is required')
          .test('age', 'Age should be greater than 18 years', (value) => {
            if (!value) return false;
            const birthDate = new Date(value);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }),
      otherwise: (schema) => schema.notRequired()
    })
});

function EditOnBoarding() {
  const [partnerType1, setPartnerType1] = useState('');
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [aadharBackPreview, setAadharBackPreview] = useState(aadharBackDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);
  const [uploadPhoto, setUploadPhoto] = useState(); // uploaded image file frontside
  const [uploadImageFileFront, setUploadImageFileFront] = useState(null); // uploaded image file frontside
  const [uploadImageFileBack, setUploadImageFileBack] = useState(null); // uploaded image file backside
  const [uploadPanImage, setUploadPanImage] = useState();
  const [uploadChequeImage, setUploadChequeImage] = useState();
  const [gstImage, setGstImage] = useState();
  const [panPreview1, setPanPreview1] = useState(panCardDummy);
  const [gstPreview, setGstPreview] = useState(gstRegistrationCertificate);
  const [incorporationPreview, setIncorporationPreview] = useState(incorporationCertificate);
  const [incorporationUploadComp, setIncorporationUploadComp] = useState();
  const [uploadPanImageCompany, setUploadPanImageCompany] = useState();
  const [chequePreview1, setChequePreview1] = useState(cancelChequeDummy);
  const [uploadChequeCompany, setUploadChequeCompany] = useState();
  const [logoPreview, setLogoPreview] = useState(logoDummy);
  const [logoUpload, setLogoUpload] = useState();
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page
  const [chequePreviewtype1, setChequePreviewtype1] = useState('');
  const [panPreviewtype1, setPanPreviewtype1] = useState('');
  const [aadharBackPreviewtype1, setAadharBackPreviewtype1] = useState('');
  const [photoPreviewtype1, setPhotoPreviewtype1] = useState('');
  const [aadharFrontPreviewtype1, setAadharFrontPreviewtype1] = useState('');
  const [chequePreview1type1, setChequePreview1type1] = useState('');
  const [panPreview1type1, setPanPreview1type1] = useState('');
  const [gstPreviewtype1, setGstPreviewtype1] = useState('');
  const [incorporationPreviewtype1, setIncorporationPreviewtype1] = useState('');
  const [logoPreviewtype1, setLogoPreviewtype1] = useState('');
  const [fileTypeId, setFileTypeId] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewFileType, setPreviewFileType] = useState('image');

  const { rowId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId: rowData, parent } = location?.state || {};

  // console.log('row data in onboarding', rowData);
  const { LoginData } = useLoginSelector();
  const { stateDrop, CityDrop, DocsTypesDrop, PartnerStatusDrop, PartnerCompanyTypesDrop } =
    useGlobalSelector();

  const handleChange = (event, newValue) => {
    setFileTypeId(newValue);
  };
  const { ReportingManagerListData } = useOnboardingSelector();
  const { OnboardingViewData: reviewData } = useOnboardingSelector();
  // console.log('Component Rendered', reviewData);

  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange', // Add this to validate on blur
    defaultValues: {
      partnerName: '',
      dob: '',
      emailAddress: '',
      mobile: '',
      misMonth: '',
      isNextUserAllowed: false,
      isPartnerLoginAllowed: false
    }
  });

  const stateSelected = watch('provinceId') || null;
  const cityId = watch('districtId');
  const relationshipManager = watch('relationshipManager');

  // console.log('cityid testing', cityId);

  const handleFileUpload = async (
    e,
    setPreview,
    setUploadImage,
    setLocaltype,
    typeCode,
    fieldName
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isPdf = file.type === 'application/pdf';

    setLocaltype(isPdf ? 'pdf' : 'image');
    setUploadImage(file);

    // Create blob URL - works for both images and PDFs
    const blobUrl = URL.createObjectURL(file);
    setPreview(blobUrl);

    // Upload instantly
    await uploadDocumentInstant(file, typeCode, fieldName);
  };

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setPageNumber(1);
  }, []);

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e, setPreview, setUploadImage, setLocaltype, typeCode, fieldName) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files[0]) {
      const file = files[0];
      const isPdf = file.type === 'application/pdf';

      setLocaltype(isPdf ? 'pdf' : 'image');
      setUploadImage(file);

      const blobUrl = URL.createObjectURL(file);
      setPreview(blobUrl);

      uploadDocumentInstant(file, typeCode, fieldName);
    }
  };

  const handlePartnerType = (e) => {
    reset();
    setPartnerType1(e.target.value);
    setPhotoPreview(photoDummy);
    setAadharFrontPreview(aadharFrontDummy);
    setAadharBackPreview(aadharBackDummy);
    setPanPreview(panCardDummy);
    setChequePreview(cancelChequeDummy);
    setGstPreview(gstRegistrationCertificate);
    setPanPreview1(panCardDummy);
    setChequePreview1(cancelChequeDummy);
    setIncorporationPreview(incorporationCertificate);
    setLogoPreview(logoDummy);
  };

  //  city api
  const handleGetCity = useCallback(
    (optionVal) => {
      if (!optionVal) {
        dispatch(setCityData([])); // city data
        setValue('districtId', null);
        return '';
      }
      const data = {
        stateId: optionVal,
        searchLiteral: ''
      };
      dispatch(getCityData(data)); // fetch city data
    },
    [LoginData?.companyId, LoginData?.userId] // dependencies
  );

  const safeSetPreview = (setter, url, dummy) => {
    if (!url || url.includes('/home/')) {
      setter(dummy);
    } else {
      setter(url);
    }
  };

  useEffect(() => {
    if (rowData) {
      setPartnerType1(rowData?.partnerType?.typeId);
      handleGetCity(rowData?.provinceId);

      setValue('partnerName', rowData?.partnerName ?? '');
      setValue('companyName', rowData?.companyName ?? rowData?.partnerName ?? '');
      setValue('fathersName', rowData?.fathersName ?? '');
      setValue('dob', rowData?.dob ?? '');
      setValue('dateOfIncorporation', rowData?.dateOfIncorporation ?? rowData?.dob ?? '');
      setValue('mobile', rowData?.mobile ?? '');
      setValue('emailAddress', rowData?.emailAddress ?? '');
      setValue('address', rowData?.address ?? '');
      setValue('provinceId', rowData?.provinceId ?? '');
      setValue('districtId', rowData?.districtId ?? '');
      setValue(
        'relationshipManager',
        rowData?.relationshipManagerId ?? rowData?.relationshipManager ?? ''
      );
      setValue('isNextUserAllowed', rowData?.isNextUserAllowed ?? false);
      setValue('isPartnerLoginAllowed', rowData?.isPartnerLoginAllowed ?? false);
      // company details
      setValue('authorisedPersonName', rowData?.authorisedPersonName ?? '');
      setValue('partnerCompanyTypeId', rowData?.partnerCompanyTypeId ?? '');
      setValue('companyGstNumber', rowData?.companyGstNumber ?? '');
      setValue('companyPanNumber', rowData?.companyPanNumber ?? '');

      if (rowData?.partnerDocuments?.length > 0) {
        rowData?.partnerDocuments?.forEach((docItem) => {
          const dataTypeCode = docItem?.documentType?.typeCode;
          const isPdf = docItem?.documentUrl?.toLowerCase().endsWith('.pdf');
          const type = isPdf ? 'pdf' : 'image';

          if (dataTypeCode === 'CHEQUE') {
            setChequePreview1(docItem?.documentUrl);
            setChequePreview1type1(type);
          }
          if (dataTypeCode === 'PAN CARD') {
            setPanPreview1(docItem?.documentUrl);
            setPanPreview1type1(type);
          }
          if (dataTypeCode === 'GSTIN') {
            setGstPreview(docItem?.documentUrl);
            setGstPreviewtype1(type);
          }
          if (dataTypeCode === 'INCORPORATION_CERTIFICATE') {
            setIncorporationPreview(docItem?.documentUrl);
            setIncorporationPreviewtype1(type);
          }
          if (dataTypeCode === 'COMPANY_LOGO') {
            setLogoPreview(docItem?.documentUrl);
            setLogoPreviewtype1(type);
          }
          if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === false) {
            setAadharBackPreview(docItem?.documentUrl);
            setAadharBackPreviewtype1(type);
          }
          if (dataTypeCode === 'USER IMAGE') {
            safeSetPreview(setPhotoPreview, docItem?.documentUrl, photoDummy);
            setPhotoPreviewtype1(type);
          }
          if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === true) {
            setAadharFrontPreview(docItem?.documentUrl);
            setAadharFrontPreviewtype1(type);
          }
        });
      }
    }
  }, [rowData]);

  async function handlePreviewDoc(typeId) {
    const { partnerId, companyId } = reviewData;

    // ✅ Revoke old URL to prevent caching issues
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    // ✅ Add timestamp to bypass cache
    const timestamp = new Date().getTime();

    const blob = await dispatch(
      PreviewImageApi(
        `pdoc/${companyId}/${partnerId}/${typeId}?t=${timestamp}`,
        null,
        true // blob mode
      )
    );

    if (!blob) {
      console.error('Failed to fetch document');
      return;
    }

    console.log('REAL BLOB:', blob);

    setPreviewFileType(blob.type === 'application/pdf' ? 'pdf' : 'image');
    const fileURL = URL.createObjectURL(blob);
    setPreviewUrl(fileURL);
    setOpenPreview(true);
  }

  const uploadDocumentInstant = async (file, typeCode, fieldName) => {
    if (!file || file.size <= 0) return;

    try {
      const formData = new FormData();
      formData.append('partnerId', reviewData?.partnerId);
      formData.append('companyId', reviewData?.companyId);

      const docType = DocsTypesDrop.find((d) => d.typeCode === typeCode);
      if (docType) formData.append('documentTypeId', docType.value);

      formData.append(fieldName, file);

      const res = await dispatch(savefileApiData(OnboardingApi?.onboardDocUpload, formData));
      // console.log('res111', res);
      if (res?.success === true) {
        dispatch(setApiError(res?.msg || 'upload successfully'));
        console.log(`${typeCode} uploaded instantly ✅`);
        dispatch(
          getOnboardingView({
            companyId: reviewData?.companyId,
            partnerId: reviewData?.partnerId
          })
        );
      } else {
        console.error(`${typeCode} upload failed ❌`, res);
      }
    } catch (err) {
      console.error(`Instant upload error (${typeCode})`, err);
    }
  };

  const onSubmit = useCallback(
    async (data) => {
      if (partnerType1 === 66) {
        if (!isValidValue(data?.dob)) {
          setError('dob', {
            type: 'manual', // 'manual' indicates programmatically set
            message: 'Date of Birth is required' // error message shown to user
          });
          return;
        } else if (data?.dob) {
          const birthDate = new Date(data?.dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          if (age < 18) {
            setError('dob', {
              type: 'manual', // 'manual' indicates programmatically set
              message: 'Age should be greater than 18 years' // error message shown to user
            });
            return ''; // Age is less than 18
          }
        }
      }
      // console.log('rowId222', rowId);
      const finalData = {
        companyId: LoginData?.companyId,
        typeId: partnerType1,
        partnerName: data?.partnerName || data?.companyName || '',
        companyName: data?.companyName ?? '',
        fathersName: data?.fathersName ?? '',
        mobile: data?.mobile ?? '',
        emailAddress: data?.emailAddress ?? '',
        dob: data?.dob ?? '',
        dateOfIncorporation: data?.dateOfIncorporation ?? '',
        companyGstNumber: data?.companyGstNumber ?? '',
        companyPanNumber: data?.companyPanNumber ?? '',
        partnerCompanyTypeId: data?.partnerCompanyTypeId ?? '',
        authorisedPersonName: data?.authorisedPersonName ?? '',
        address: data?.address ?? '',
        relationshipManagerId: data?.relationshipManager ?? null,
        isPartnerLoginAllowed: data?.isPartnerLoginAllowed ?? false,
        isNextUserAllowed: data?.isNextUserAllowed ?? false,
        isSignUpFlow: true,
        partnerId: rowId,
        districtId: cityId
      };

      // console.log('cityId in payload', finalData);

      try {
        const res = await dispatch(saveApiData(OnboardingApi?.onboardUpdate, finalData));
        if (res?.status === 'success') {
          const PartnerId = res?.data?.partnerId;
          const CompanyIds = res?.data?.companyId;

          // if (res?.data?.isPartnerAlreadyExist) {
          //   dispatch(setApiError('Mobile Number Already Available'));
          //   return;
          // }

          // Reusable document upload function
          // const uploadDocument = async (file, typeCode, fieldName) => {
          //   if (!file || file.size <= 0) return;

          //   try {
          //     const formData = new FormData();
          //     formData.append('partnerId', reviewData?.partnerId);
          //     formData.append('companyId', reviewData?.companyId);

          //     const docType = DocsTypesDrop.find((item) => item.typeCode === typeCode);
          //     if (docType) formData.append('documentTypeId', docType.value);

          //     formData.append(fieldName, file);

          //     const result = await dispatch(saveApiData(OnboardingApi?.onboardDocUpload, formData));

          //     if (result && result.status === 'success') {
          //       console.log(`${typeCode} upload successful:`, result);
          //     } else {
          //       console.error(`${typeCode} upload failed:`, result);
          //     }
          //   } catch (error) {
          //     console.error(`Error uploading ${typeCode}:`, error);
          //   }
          // };

          // List of documents to upload
          const documents = [
            { file: uploadPhoto, typeCode: 'USER IMAGE', fieldName: 'userImage' },
            { file: uploadImageFileFront, typeCode: 'AADHAR CARD', fieldName: 'aadharFront' },
            { file: uploadImageFileBack, typeCode: 'AADHAR CARD', fieldName: 'aadharBack' },
            { file: uploadPanImage, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeImage, typeCode: 'CHEQUE', fieldName: 'cheque' },
            { file: logoUpload, typeCode: 'COMPANY_LOGO', fieldName: 'companyLogo' },
            { file: gstImage, typeCode: 'GSTIN', fieldName: 'gstInDocument' },
            {
              file: incorporationUploadComp,
              typeCode: 'INCORPORATION_CERTIFICATE',
              fieldName: 'incorporationCertificate'
            },
            { file: uploadPanImageCompany, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeCompany, typeCode: 'CHEQUE', fieldName: 'cheque' }
          ];

          // Promise.all(documents.map((doc) => uploadDocument(doc.file, doc.typeCode, doc.fieldName)))
          //   .then(() => {
          //     console.log('All document uploads finished');
          //   })
          //   .catch((err) => {
          //     console.error('One or more document uploads failed', err);
          //   });

          localStorage.setItem('partnerId', PartnerId);
          navigate('/onboarding');
        } else {
          console.warn('onboardUpdate did not return success:', res);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [
      LoginData,
      partnerType1,
      cityId,
      uploadPhoto,
      uploadImageFileFront,
      uploadImageFileBack,
      uploadPanImage,
      uploadChequeImage,
      logoUpload,
      gstImage,
      incorporationUploadComp,
      uploadPanImageCompany,
      uploadChequeCompany
    ] // 🔹 depends on LoginData
  );

  //  state list
  const getStateList = () => {
    const data = {
      countryId: 101
    };
    dispatch(getStateData(data));
  };

  useEffect(() => {
    dispatch(getPartnerTypesData()); // partner types
    dispatch(getPartnerCompanyType()); // partner company types
    dispatch(getDocsTypesData()); // docs types
    getStateList(); // state list
  }, []);

  useEffect(() => {
    const list = ReportingManagerListData || [];
    const selected = list.find((u) => String(u.userId) === String(relationshipManager));
    const name = selected ? selected.fullName || selected.email || '' : '';
    sessionStorage.setItem('relationshipManagerSelected', name);
  }, [relationshipManager, ReportingManagerListData]);

  const getReportingManagerListApi = useCallback(() => {
    if (!LoginData || !cityId) return;
    const credentials = {
      cityId: cityId
    };
    // console.log('sss credentials', credentials);
    dispatch(getReportingManagerList(credentials));
  }, [LoginData, cityId, dispatch]);

  useEffect(() => {
    getReportingManagerListApi();
  }, [getReportingManagerListApi]);

  useEffect(() => {
    const credential = {
      companyId: LoginData?.companyId || '',
      partnerId: rowId
    };
    dispatch(getOnboardingView(credential));
  }, []);

  useEffect(() => {
    if (reviewData?.partnerDocuments?.length > 0) {
      reviewData.partnerDocuments.forEach(async (docItem) => {
        if (docItem?.documentUrl) {
          const dataTypeCode = docItem?.documentType?.typeCode;
          const endpoint = docItem.documentUrl.startsWith('/')
            ? docItem.documentUrl.substring(1)
            : docItem.documentUrl;
          const blob = await dispatch(PreviewImageApi(endpoint, null, true));
          if (blob) {
            const objectUrl = URL.createObjectURL(blob);
            if (dataTypeCode === 'USER IMAGE') setPhotoPreview(objectUrl);
            if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === true)
              setAadharFrontPreview(objectUrl);
            if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === false)
              setAadharBackPreview(objectUrl);
            if (dataTypeCode === 'PAN CARD') {
              setPanPreview(objectUrl);
              setPanPreview1(objectUrl);
            }
            if (dataTypeCode === 'CHEQUE') {
              setChequePreview(objectUrl);
              setChequePreview1(objectUrl);
            }
            if (dataTypeCode === 'GSTIN') setGstPreview(objectUrl);
            if (dataTypeCode === 'INCORPORATION_CERTIFICATE') setIncorporationPreview(objectUrl);
            if (dataTypeCode === 'COMPANY_LOGO') setLogoPreview(objectUrl);
          }
        }
      });
    }
  }, [reviewData, dispatch]);

  console.log('reviewData', reviewData);

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle
              info={
                parent === 'partner' ? 'Partner View' : rowId ? 'Edit Partner' : 'Add New Partner'
              }
            />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          {/* === Tabs === */}
          {parent === 'on-boarding' ? (
            <Tabs
              value={fileTypeId}
              onChange={handleChange}
              className="tabOuter"
              aria-label="revenue tabs"
              classes={{ indicator: 'tabIndicator' }}
              sx={{ mb: 3 }}
            >
              <Tab
                label="Partner Details"
                value={0}
                classes={{ selected: 'tabSelected', root: 'tabDefault' }}
              />
              {/* <Tab
                label="User Level"
                value={1}
                classes={{ selected: 'tabSelected', root: 'tabDefault' }}
              /> */}
            </Tabs>
          ) : null}
          {fileTypeId === 0 && (
            <>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Box mb={3}>
                    <Typography variant="h6" className="formLabel">
                      Partner Type
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={partnerType1}
                      onChange={(e) => {
                        handlePartnerType(e);
                      }}
                    >
                      {PartnerStatusDrop?.length > 0 &&
                        PartnerStatusDrop?.map((item, index) => (
                          <MenuItem value={item?.value} key={item?.value}>
                            {item?.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Grid>
              </Grid>
              <form id="myEditOnboardingForm" onSubmit={handleReduxSubmit(onSubmit)}>
                {partnerType1 &&
                  (partnerType1 === 66 ? (
                    <>
                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Individual Details
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                        <Grid container spacing={3} mb={3}>
                          <Grid item xs={4}>
                            <CustomInput
                              name="partnerName"
                              label="Full Name"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="NAME"
                              fieldType="ALPHABET"
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="fathersName"
                              label="Father Name"
                              control={control}
                              errors={errors}
                              isRequired
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomDate
                              name="dob"
                              label="Date of Birth"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="DATE"
                              fieldType="DATE_FIELD"
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="mobile"
                              label="Mobile"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="MOBILE"
                              type="Number"
                              // disabled={parent === 'partner' ? true : false}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="emailAddress"
                              label="Email"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="EMAIL"
                              fieldType="TEXT_FIELD"
                              // disabled={parent === 'partner' ? true : false}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="address"
                              label="Address"
                              control={control}
                              // errors={errors}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="provinceId"
                              label="State"
                              control={control}
                              errors={errors}
                              options={stateDrop || []}
                              onChange={(event, val, option, reason, details) => {
                                handleGetCity(val);
                              }}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="districtId"
                              label="City"
                              control={control}
                              errors={errors}
                              options={CityDrop || []}
                              disabled={!stateSelected || (parent === 'partner' ? true : false)}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="relationshipManager"
                              label="Relationship manager"
                              control={control}
                              errors={errors}
                              options={
                                ReportingManagerListData.map((user) => ({
                                  value: user.userId,
                                  label: user.fullName
                                })) || []
                              }
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="isNextUserAllowed"
                              label="Next User Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="isPartnerLoginAllowed"
                              label="Reco Engine Access"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Upload Documents
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                        <Grid container spacing={3}>
                          {/* Photo */}
                          {(() => {
                            const photoDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'USER IMAGE'
                            );
                            return (
                              <Grid item xs={4}>
                                <Box className="">
                                  <Box
                                    sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
                                  >
                                    <Typography variant="h6" className="formLabel">
                                      Photo
                                    </Typography>
                                    {photoDoc && (
                                      <VisibilityIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() =>
                                          handlePreviewDoc(photoDoc?.partnerDocumentId)
                                        }
                                      />
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    className="fileInput"
                                    id="contained-button-file1"
                                    disabled={parent === 'partner' ? true : false}
                                    multiple
                                    type="file"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setPhotoPreview,
                                        setUploadPhoto,
                                        setPhotoPreviewtype1,
                                        'USER IMAGE',
                                        'userImage'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file1"
                                    className={
                                      photoPreviewtype1 === 'pdf'
                                        ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                        : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                    }
                                  >
                                    <Box
                                      variant="contained"
                                      color="primary"
                                      component="span"
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setPhotoPreview,
                                          setUploadPhoto,
                                          setPhotoPreviewtype1,
                                          'USER IMAGE', // ← Add this
                                          'userImage'
                                        )
                                      }
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      {photoPreviewtype1 === 'pdf' ? (
                                        // <Document
                                        //   file={photoPreview}
                                        //   onLoadSuccess={(numPages) =>
                                        //     onDocumentLoadSuccess(numPages)
                                        //   }
                                        // >
                                        //   <Pages
                                        //     pageNumber={pageNumber}
                                        //     renderTextLayer={false}
                                        //     renderAnnotationLayer={false}
                                        //   />
                                        // </Document>
                                        <img
                                          src={photoPreview}
                                          alt="Person"
                                          className="previewImage"
                                        />
                                      ) : (
                                        <img
                                          src={photoPreview}
                                          alt="Person"
                                          className="previewImage"
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {photoDoc && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: 'green', fontWeight: 600, mt: 1 }}
                                    >
                                      ✓ Document uploaded
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* Aadhar Front */}
                          {(() => {
                            const aadharFrontDoc = reviewData?.partnerDocuments?.find(
                              (doc) =>
                                doc?.documentType?.typeCode === 'AADHAR CARD' &&
                                doc?.aadharFrontFace === true
                            );
                            return (
                              <Grid item xs={4}>
                                <Box className="">
                                  <Box
                                    sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
                                  >
                                    <Typography variant="h6" className="formLabel">
                                      Aadhar
                                    </Typography>
                                    {aadharFrontDoc && (
                                      <VisibilityIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() =>
                                          handlePreviewDoc(aadharFrontDoc?.partnerDocumentId)
                                        }
                                      />
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    className="fileInput"
                                    id="contained-button-file2"
                                    disabled={parent === 'partner' ? true : false}
                                    multiple
                                    type="file"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setAadharFrontPreview,
                                        setUploadImageFileFront,
                                        setAadharFrontPreviewtype1,
                                        'AADHAR CARD',
                                        'aadharFront'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file2"
                                    className={
                                      aadharFrontPreviewtype1 === 'pdf'
                                        ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                        : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                    }
                                  >
                                    <Box
                                      variant="contained"
                                      color="primary"
                                      component="span"
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setAadharFrontPreview,
                                          setUploadImageFileFront,
                                          setAadharFrontPreviewtype1,
                                          'AADHAR CARD', // ← Add this
                                          'aadharFront'
                                        )
                                      }
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      {aadharFrontPreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={aadharFrontPreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={aadharFrontPreview}
                                          alt="Aadhar Front"
                                          className="previewImage"
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {aadharFrontDoc && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: 'green', fontWeight: 600, mt: 1 }}
                                    >
                                      ✓ Verified Document
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* PAN Card */}
                          {(() => {
                            const panDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'PAN CARD'
                            );
                            return (
                              <Grid item xs={4}>
                                <Box className="">
                                  <Box
                                    sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
                                  >
                                    <Typography variant="h6" className="formLabel">
                                      PAN Card
                                    </Typography>
                                    {panDoc && (
                                      <VisibilityIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => handlePreviewDoc(panDoc?.partnerDocumentId)}
                                      />
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    className="fileInput"
                                    id="contained-button-file4"
                                    disabled={parent === 'partner' ? true : false}
                                    multiple
                                    type="file"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setPanPreview,
                                        setUploadPanImage,
                                        setPanPreviewtype1,
                                        'PAN CARD',
                                        'panCard'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file4"
                                    className={
                                      panPreviewtype1 === 'pdf'
                                        ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                        : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                    }
                                  >
                                    <Box
                                      variant="contained"
                                      color="primary"
                                      component="span"
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setPanPreview,
                                          setUploadPanImage,
                                          setPanPreviewtype1
                                        )
                                      }
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      {panPreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={panPreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={panPreview}
                                          alt="Pan Card"
                                          className="previewImage"
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {panDoc && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: 'green', fontWeight: 600, mt: 1 }}
                                    >
                                      ✓ Verified Document
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* Cancelled Cheque */}
                          {(() => {
                            const chequeDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'CHEQUE'
                            );
                            return (
                              <Grid item xs={4}>
                                <Box className="">
                                  <Box
                                    sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
                                  >
                                    <Typography variant="h6" className="formLabel">
                                      Cancelled Cheque
                                    </Typography>
                                    {chequeDoc && (
                                      <VisibilityIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() =>
                                          handlePreviewDoc(chequeDoc?.partnerDocumentId)
                                        }
                                      />
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    className="fileInput"
                                    id="contained-button-file5"
                                    disabled={parent === 'partner' ? true : false}
                                    multiple
                                    type="file"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setChequePreview,
                                        setUploadChequeImage,
                                        setChequePreviewtype1,
                                        'CHEQUE',
                                        'cheque'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file5"
                                    className={
                                      chequePreviewtype1 === 'pdf'
                                        ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                        : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                    }
                                  >
                                    <Box
                                      variant="contained"
                                      color="primary"
                                      component="span"
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setChequePreview,
                                          setUploadChequeImage,
                                          setChequePreviewtype1
                                        )
                                      }
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      {chequePreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={chequePreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={chequePreview}
                                          alt="Cancel Cheque"
                                          className="previewImage"
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {chequeDoc && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: 'green', fontWeight: 600, mt: 1 }}
                                    >
                                      ✓ Verified Document
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}
                        </Grid>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Company Details
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                        <Grid container spacing={3} mb={3}>
                          <Grid item xs={4}>
                            <CustomInput
                              name="companyName"
                              label="Company Name"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="NAME"
                              fieldType="ALPHABET"
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="authorisedPersonName"
                              label="Authorised Person Name"
                              control={control}
                              // errors={errors}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="mobile"
                              label="Mobile Number"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="MOBILE"
                              fieldType="NUMBER_FIELD"
                              type="Number"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="emailAddress"
                              label="Email"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="EMAIL"
                              fieldType="TEXT_FIELD"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="partnerCompanyTypeId"
                              label="Company Type"
                              control={control}
                              errors={errors}
                              options={PartnerCompanyTypesDrop || []}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomDate
                              name="dateOfIncorporation"
                              label="Date of Incorporation"
                              control={control}
                              // errors={errors}
                              fieldCode="DATE"
                              fieldType="DATE_FIELD"
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="companyGstNumber"
                              label="GST Number"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="companyPanNumber"
                              label="PAN Number"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomInput
                              name="address"
                              label="Address"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="provinceId"
                              label="State"
                              control={control}
                              errors={errors}
                              options={stateDrop || []}
                              onChange={(event, val, option, reason, details) => {
                                handleGetCity(val);
                              }}
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="districtId"
                              label="City"
                              control={control}
                              errors={errors}
                              options={CityDrop || []}
                              disabled={!stateSelected || (parent === 'partner' ? true : false)}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="relationshipManager"
                              label="Relationship manager"
                              control={control}
                              errors={errors}
                              options={
                                ReportingManagerListData.map((user) => ({
                                  value: user.userId,
                                  label: user.fullName
                                })) || []
                              }
                              disabled={parent === 'partner' ? true : false}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="isNextUserAllowed"
                              label="Next User Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              name="isPartnerLoginAllowed"
                              label="Partner Login Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                        </Grid>{' '}
                      </Box>
                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Upload Documents
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <Box className="">
                              <Typography variant="h6" className="formLabel">
                                GST Certificate
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                className="fileInput"
                                id="contained-button-file7"
                                disabled={parent === 'partner' ? true : false}
                                multiple
                                type="file"
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setGstPreview,
                                    setGstImage,
                                    setGstPreviewtype1,
                                    'GSTIN',
                                    'gstInDocument'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file7"
                                className={
                                  gstPreviewtype1 === 'pdf'
                                    ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                    : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                }
                              >
                                <Box
                                  variant="contained"
                                  color="primary"
                                  component="span"
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setGstPreview,
                                      setGstImage,
                                      setGstPreviewtype1,
                                      'GSTIN',
                                      'gstInDocument'
                                    )
                                  }
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  {/* <img src={gstPreview} alt="GST Certificate" className="previewImage" /> */}

                                  {gstPreviewtype1 === 'pdf' ? (
                                    <Document
                                      file={gstPreview}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={gstPreview}
                                      alt="GST Certificate"
                                      className="previewImage"
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>

                          <Grid item xs={4}>
                            <Box className="">
                              <Typography variant="h6" className="formLabel">
                                PAN Card
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                className="fileInput"
                                id="contained-button-file9"
                                disabled={parent === 'partner' ? true : false}
                                multiple
                                type="file"
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setPanPreview1,
                                    setUploadPanImageCompany,
                                    setPanPreview1type1,
                                    'PAN CARD',
                                    'panCard'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file9"
                                className={
                                  panPreview1type1 === 'pdf'
                                    ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                    : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                }
                              >
                                <Box
                                  variant="contained"
                                  color="primary"
                                  component="span"
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setPanPreview1,
                                      setUploadPanImageCompany,
                                      setPanPreview1type1,
                                      'PAN CARD',
                                      'panCard'
                                    )
                                  }
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  {/* <img src={panPreview1} alt="Pan Card" className="previewImage" /> */}

                                  {panPreview1type1 === 'pdf' ? (
                                    <Document
                                      file={panPreview1}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={panPreview1}
                                      alt="Pan Card"
                                      className="previewImage"
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className="">
                              <Typography variant="h6" className="formLabel">
                                Cancelled Cheque
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                className="fileInput"
                                id="contained-button-file10"
                                disabled={parent === 'partner' ? true : false}
                                multiple
                                type="file"
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setChequePreview1,
                                    setUploadChequeCompany,
                                    setChequePreview1type1,
                                    'CHEQUE',
                                    'cheque'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file10"
                                className={
                                  chequePreview1type1 === 'pdf'
                                    ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                    : `uploadDocBoxLabel uploadDocBoxLabelFull`
                                }
                              >
                                <Box
                                  variant="contained"
                                  color="primary"
                                  component="span"
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setChequePreview1,
                                      setUploadChequeCompany,
                                      setChequePreview1type1,
                                      'CHEQUE',
                                      'cheque'
                                    )
                                  }
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  {chequePreview1type1 === 'pdf' ? (
                                    <Document
                                      file={chequePreview1}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={chequePreview1}
                                      alt="Cancel Cheque"
                                      className="previewImage"
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  ))}
              </form>
              <Box textAlign="right">
                {parent !== 'partner' && (
                  <Button
                    type="submit"
                    form="myEditOnboardingForm"
                    variant="contained"
                    className="mainBtn"
                  >
                    Save
                  </Button>
                )}
              </Box>
            </>
          )}
          {fileTypeId === 1 && <PartnerHierarchyPage partnerId={rowId} />}
        </Box>
        <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
          <DialogTitle>Document Preview</DialogTitle>

          <DialogContent dividers>
            {previewUrl && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                {previewFileType === 'pdf' ? (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      bgcolor: '#f5f5f5',
                      p: 2,
                      borderRadius: 1,
                      overflow: 'auto',
                      maxHeight: '70vh'
                    }}
                  >
                    <Document
                      file={previewUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<div>Loading PDF...</div>}
                    >
                      <Pages
                        pageNumber={pageNumber}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </Document>
                  </Box>
                ) : (
                  <Box
                    component="img"
                    src={previewUrl}
                    alt="Preview"
                    sx={{
                      width: '100%',
                      maxHeight: 500,
                      objectFit: 'contain'
                    }}
                  />
                )}
              </Box>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenPreview(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
export default EditOnBoarding;
